import React, { useState } from "react";

const availableSlots = [
  "3:00 pm", "3:15 pm", "3:30 pm", "3:45 pm",
  "4:00 pm", "4:15 pm", "4:30 pm"
];

export default function Scheduler() {
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today); // ⬅️ Default selected date
  const [selectedTime, setSelectedTime] = useState(null);
  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "" });

  const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();

  const handleDateClick = (day) => {
    setSelectedDate(new Date(today.getFullYear(), today.getMonth(), day));
    setSelectedTime(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    alert("Meeting booked successfully!");
  };

  const handleBack = () => {
    setSelectedTime(null);
  };

  return (
    <div className=" bg-slate-100 flex items-center justify-center py-40 px-4 ">
      <div className="bg-white rounded-lg shadow-xl flex w-full max-w-6xl overflow-hidden flex-col md:flex-row">

        {/* Calendar Section (hidden after slot selected) */}
        {!selectedTime && (
          <div className="bg-slate-800 text-white p-6 w-full md:w-1/2">
            <div className="text-center">
              <div className="rounded-full w-16 h-16 mx-auto bg-teal-500 mb-4" />
              <h2 className="text-xl font-semibold">Meet with You</h2>
              <p className="text-sm text-gray-300 mb-4">
                {today.toLocaleString("default", { month: "long" })} {today.getFullYear()}
              </p>
            </div>

            <div className="grid grid-cols-7 gap-2 text-center text-sm font-medium">
              {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((day) => (
                <div key={day} className="text-gray-400">{day}</div>
              ))}

              {Array.from({ length: daysInMonth }, (_, i) => {
                const day = i + 1;
                return (
                  <button
                    key={day}
                    onClick={() => handleDateClick(day)}
                    className={`py-2 rounded-full transition ${selectedDate?.getDate() === day
                        ? "bg-white text-black font-bold"
                        : "hover:bg-white/10"
                      }`}
                  >
                    {day}
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* Right Section (Slots/Form) */}
        <div className={`p-6 w-full  ${selectedTime ? "md:w-full" : "md:w-1/2"}`}>
          {!selectedTime ? (
            <>
              <h3 className="text-lg font-semibold mb-2">Available Slots</h3>
              <p className="text-sm text-gray-500 mb-4">
                Showing slots for{" "}
                <span className="font-medium text-gray-700">
                  {selectedDate.toDateString()}
                </span>
              </p>
              <div className="space-y-2">
                {availableSlots.map((slot) => (
                  <button
                    key={slot}
                    onClick={() => setSelectedTime(slot)}
                    className="w-full border border-gray-300 rounded-md py-2 hover:bg-gray-100 transition"
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5 h-96">
              <h3 className="text-xl font-bold text-gray-800">Your Information</h3>
              <p className="text-md font-bold text-gray-60 space-x-3 text-gray-600">
                <strong className="ml-2">{selectedDate.toDateString()}</strong> at <strong>{selectedTime}</strong>
              </p>

              <div className="flex flex-col md:flex-row gap-4">
                <input
                  type="text"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                  className="w-full border px-4 py-2 rounded-md"
                  required
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                  className="w-full border px-4 py-2 rounded-md"
                  required
                />
              </div>

              <input
                type="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full border px-4 py-2 rounded-md"
                required
              />

              <div className="flex justify-between gap-4">
                <button
                  type="button"
                  onClick={handleBack}
                  className="w-1/2 border border-gray-400 text-gray-700 py-2 rounded-md"
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="w-1/2 bg-purple-600 hover:bg-purple-700 text-white py-2 rounded-md"
                >
                  Confirm
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
